import { Container, Grid } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useRouter } from 'next/router'
import React, { PropsWithChildren, useMemo } from 'react'
import { Breadcrumbs, Breadcrumb } from '../../components/breadcrumbs/Breadcrumbs'
import { isNotNull, nonNull } from '../../utils/nonNull'
import { StyledHeading } from '../home'
import { Banner } from './fragments/banner'
import { NewsLandingCTA } from './fragments/cta'
import { NewsLandingLinks } from './fragments/links'
import { NewsFilters } from './fragments/newsFilter'
import {
  PopularGuidesAndArticlesWrapper,
  StyledBgContainer, StyledFeaturedArticlesContainer,
  StyledSectionWrapper,
} from './templateStyles'
import { StyledWrapper } from '../../fragments/secondaryPageBanner'
import { NewsLandingQuery } from '@gql'
import { StyledGlossaryTitle, StyledSecondaryBanner } from '../glossary/fragments'
import { StyledSubtitle } from '../../components/secondarybanner/StyledSecondaryBanner'

export type NewsLandingProps = NewsLandingQuery & {
    //
}

export const NewsLanding: React.FC<PropsWithChildren<NewsLandingProps>> = ({ entry, globalSet, categories, entries: baseEntries, entryCount: baseEntryCount }) => {
  if (!entry || entry.__typename !== 'newsLandingPage_newsLandingPage_Entry') {
    return null
  }

  const theme = useTheme()
  const router = useRouter()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  let imageFallbackUrl: string | undefined

  if(isNotNull(globalSet) && globalSet.__typename === 'siteSettings_GlobalSet' && isNotNull(globalSet.newsFallbackImage) && isNotNull(globalSet.newsFallbackImage[0]))
  {
    imageFallbackUrl = globalSet.newsFallbackImage?.[0]?.url??''
  }

  const breadcrumbs = useMemo(() => (
    <Breadcrumbs>
      <Breadcrumb href={'/'} home text={'Home'} />
      <Breadcrumb href={router.pathname} text={'News'} />
    </Breadcrumbs>
  ), [router])

  return (
    <>
      <StyledWrapper>
        <StyledSecondaryBanner image breadcrumbs={!isMobile ? breadcrumbs : null} src={undefined} glossary={true}>
          <StyledGlossaryTitle variant="h1">{'Credit Union SA News'}</StyledGlossaryTitle>
          <StyledSubtitle>{'Community'}</StyledSubtitle>
        </StyledSecondaryBanner>
      </StyledWrapper>

      {entry.newsLandingBanner?.[0]?.newsArticleSelect && (
        <StyledFeaturedArticlesContainer>
          <StyledSectionWrapper direction={'column'} container>
            <Grid item component={'section'}>
              {/** @ts-ignore */}
              <Banner data={nonNull(entry.newsLandingBanner[0].newsArticleSelect)} imageFallbackUrl={imageFallbackUrl} />
            </Grid>
          </StyledSectionWrapper>
        </StyledFeaturedArticlesContainer>
      )}
      <StyledBgContainer>
        <Container maxWidth={'lg'}>
          <NewsFilters entry={entry} categories={categories} entries={baseEntries} entryCount={baseEntryCount} globalSet={globalSet} />
          {entry.twoColumnCta && (
            <StyledSectionWrapper direction={'column'} alignItems={'center'} container>
              <Grid item xs={12} component={'section'}>
                <NewsLandingCTA data={nonNull(entry.twoColumnCta)}/>
              </Grid>
            </StyledSectionWrapper>
          )}
        </Container>
      </StyledBgContainer>
      {entry.popularGuideArticles && (
        <PopularGuidesAndArticlesWrapper maxWidth={'lg'}>
          <StyledSectionWrapper direction={'column'} alignItems={'center'} container>
            <Grid item xs={12} component={'section'}>
              <StyledHeading variant="h5" align="center">
                {'POPULAR GUIDES AND ARTICLES'}
              </StyledHeading>
            </Grid>
            <Grid item xs={12} component={'section'}>
              <NewsLandingLinks data={nonNull(entry.popularGuideArticles)} />
            </Grid>
          </StyledSectionWrapper>
        </PopularGuidesAndArticlesWrapper>
      )}
    </>
  )
}